module.exports = __webpack_public_path__ + "img/8_68.e5827897.png";